var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 54,
    viewBox: "0 0 32 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g81gb9pzya",
    d: "M0 0L32 0 32 54 0 54z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-172 -1097) translate(172 1097)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6c86yjpczb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g81gb9pzya"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FA7700",
    d: "M29.58 10.188c0 .273-.227.495-.505.495H2.925c-.278 0-.505-.222-.505-.495V2.87c0-.273.227-.495.505-.495h26.15c.278 0 .505.222.505.495v7.317zm-4.054 40.94c0 .274-.227.496-.505.496H6.98c-.278 0-.505-.222-.505-.496v-6.401H18.99V42.35H6.474v-8.235h6.29V31.74h-6.29v-8.692H18.99v-2.376H6.474v-7.116c0-.274.227-.496.505-.496h18.042c.278 0 .505.222.505.496v37.572zM29.075 0H2.925C1.312 0 0 1.288 0 2.871v7.317c0 1.583 1.312 2.871 2.925 2.871h1.176c-.029.162-.047.327-.047.497v37.572C4.054 52.712 5.366 54 6.979 54h18.042c1.613 0 2.925-1.288 2.925-2.872V13.556c0-.17-.018-.335-.047-.497h1.176c1.613 0 2.925-1.288 2.925-2.871V2.87C32 1.288 30.688 0 29.075 0z",
    mask: "url(#6c86yjpczb)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxArrowRight);
export default __webpack_public_path__ + "static/media/box-arrow-right.2f5d5453.svg";
export { ForwardRef as ReactComponent };